export default __webpack_public_path__ + "static/data-more-about-img2--mobile-bd591ad3652815d1d3383724698cd32a.webp";